import { isLocale, type Locale } from "@tovi/shared";

/**
 * The terminal's own language preference.
 *
 * Not the till's language — the **store's** first language wins once `/me`
 * answers, and that rule is `main.tsx`'s. This covers the window before there
 * is a store to ask about, which is the whole of the sign-in screen, and it
 * persists so a technician setting up a room of terminals sets the language
 * once per device rather than once per launch.
 *
 * `localStorage`, like the bearer token in `api.ts`, for the same reason: it is
 * a fact about this device and nothing else reads it.
 */
const LOCALE_KEY = "tovi.pos.locale";

export function preferredLocale(): Locale | null {
  const stored = localStorage.getItem(LOCALE_KEY);
  return stored && isLocale(stored) ? stored : null;
}

export function setPreferredLocale(value: Locale): void {
  localStorage.setItem(LOCALE_KEY, value);
}
